import mfaReminder from "./mfa-reminder.js";

class Reminder {
  constructor(userReminders) {
    let {reminders} = userReminders;
    this.reminders = reminders;
    this.choseReminder();
  }

  choseReminder() {
    const reminders = this.reminders;
    for (let reminderName in reminders) {
      switch(reminderName) {
        case 'mfaReminder':
          this.runMfaReminder(reminders[reminderName]);
          break;
        default:
          break;
      }
    }
  }

  runMfaReminder(reminder) {
    mfaReminder.startReminder(reminder)
      .then(mfaReminder.renderHTML)
      .then(mfaReminder.bindPopupEvents)
      .catch(() => {});
  }
}

export default Reminder;
